import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";

import { ContentBlock } from "@/components/wpl/content-block/src/content-block";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { Row } from "@/libraries/wpl/foundations/src/grid";

const heroContainerStyles = css({
    "padding": "96px 0",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "minHeight": 0,
    "maxWidth": "fit-content",
    "margin": "0 auto",
    "gap": "32px",

    [media.below.md]: {
        padding: "64px 0"
    },
    [media.below.sm]: {
        flexDirection: "column",
        padding: "32px 0 64px 0"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".contentBlock-linkFlex": {
        margin: "0"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".textContainerStyles": {
        "maxWidth": "368px",
        [media.only.sm]: {
            flex: 1
        },
        // Tech debt: Adding this disable to unblock commits for GWP-2646
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".text-section": {
            gap: "8px",
            // Tech debt: Adding this disable to unblock commits for GWP-2646
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            h2: {
                color: wacToken("color.primary.black"),
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "48px",
                fontSize: "2.5rem",
                marginBlockEnd: "0",
                [media.below.md]: {
                    fontSize: "2.25rem",
                    lineHeight: "2.625rem"
                },
                [media.below.sm]: {
                    fontSize: "2rem",
                    lineHeight: "2.375rem"
                }
            },
            // Tech debt: Adding this disable to unblock commits for GWP-2646
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            p: {
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                marginBlockEnd: "8px",
                fontSize: "1rem",
                color: wacToken("color.primary.black")
            },
            // Tech debt: Adding this disable to unblock commits for GWP-2646

            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                margin: "0 !important"
            },

            [media.below.sm]: {
                alignItems: "center",
                textAlign: "center"
            }
        }
    }
});

const imageContainerStyles = css({
    width: "100%",
    maxWidth: "568px",
    height: "300px",
    flex: "none",

    [media.below.md]: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        height: "unset",
        maxWidth: "100%"
    },

    [media.below.sm]: {
        height: "164.261px",
        maxWidth: "311px"
    }
});

const imageStyles = css({
    maxWidth: "100%"
});

export const FinalCTASectionImage = () => {
    return (
        <div css={imageContainerStyles}>
            {/* eslint-disable-next-line no-restricted-syntax */}
            <img
                alt=""
                css={imageStyles}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-cta.webp"
                loading="lazy"
            />
        </div>
    );
};

export const FinalCTASection = () => {
    const intl = useIntl();

    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CtaSection.Header",
        defaultMessage: "Bring the big picture into view for the whole team"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CtaSection.Description",
        defaultMessage:
            "Connect all of your teams with Jira, and launch your next big idea."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Cta.TryJiraFree",
        defaultMessage: "Try Jira free"
    });

    return (
        <UFOSegment name="hero">
            <Row layout="12">
                <div css={heroContainerStyles}>
                    <FinalCTASectionImage />
                    <ContentBlock
                        headerText={headerText}
                        headerType="h2"
                        bodyText={descriptionText}
                        className="textContainerStyles"
                        ctaProps={{
                            buttonProps: {
                                value: buttonText,
                                href: useLocalizedHref("/software/jira/free"),
                                variant: "primary",
                                color: "blue",
                                dangerouslySetInnerHTML: { __html: buttonText },
                                dataEventProps: {
                                    "data-product-key": "jiraSoftware",
                                    "data-event": "clicked",
                                    "data-event-container": "ctaSection",
                                    "data-event-component": "linkButton"
                                }
                            }
                        }}
                    />
                </div>
            </Row>
        </UFOSegment>
    );
};
